// extracted by mini-css-extract-plugin
export default {"container":"bS9mLceYW3El4ljUdXHu"};